import { render } from "./icon-audio.vue?vue&type=template&id=1e2ca65c&ts=true"
import script from "./icon-audio.vue?vue&type=script&lang=ts"
export * from "./icon-audio.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__